(function ($) {

    function sliderBullets(){
        $('.design-slider').each(function(){
            const slider = $(this);
            const swiper = $(this).find('.swiper-container')[0].swiper;
            swiper.params.pagination.type = 'bullets';
            swiper.params.pagination.renderBullet = function (index, className) {
                const slides = slider.find('.swiper-slide');
                const color = slides[index]?.dataset.color || '#666';
                return `<span class="${className}" style="color: ${color}"></span>`;
            };
            swiper.pagination.destroy();
            swiper.pagination.init();
            swiper.pagination.render();
            swiper.pagination.update();
        })
    }


    var w = $(window).width();
    $( window ).on('resize', function() {
        if ($(window).width()==w) return;
        w = $(window).width();
        sliderBullets();
    });

    $(document).gp_ready(function(){
        sliderBullets();

        const swiperMain = $('.design-slider-in').find('.swiper-container')[0].swiper;
        const swiperSecondary = $('.design-slider-out').find('.swiper-container')[0].swiper;

        let isSyncing = false;

        function syncSwipers(source, target) {
            source.on('slideChange', () => {
                if (isSyncing) return;

                isSyncing = true;

                const sourceIndex = source.activeIndex;

                target.slideTo(sourceIndex, source.params.speed, false);

                setTimeout(() => {
                    isSyncing = false;
                }, source.params.speed + 20);
            });
        }

        syncSwipers(swiperMain, swiperSecondary);
        syncSwipers(swiperSecondary, swiperMain);

    });

})(jQuery);
